import React from 'react';
import { Fab, Badge } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { useChat } from './ChatContext';
import { useSelector } from 'react-redux';

const ChatFloatingButton: React.FC = () => {
    const { setIsChatOpen, isChatOpen, activeChats } = useChat();
    const user = useSelector((state: any) => state.user.user);

    // Calculate unread messages if applicable, for now just show total chats or something
    // const unreadCount = activeChats.reduce((acc, chat) => acc + (chat.unreadCount || 0), 0);
    const unreadCount = 0;

    // Hide button for scouts if they have no active chats
    if (user?.role === 'scout' && activeChats.length === 0) {
        return null;
    }

    return (
        <Fab
            color="primary"
            aria-label="chat"
            onClick={() => setIsChatOpen(!isChatOpen)}
            sx={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                zIndex: 1000
            }}
        >
            <Badge badgeContent={unreadCount} color="error">
                <ChatIcon />
            </Badge>
        </Fab>
    );
};

export default ChatFloatingButton;
